var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":"","mb-5":"","pb-5":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h1',{staticClass:"title-modal"},[_vm._v("Eliminar Área")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","info--text":"","bold-1":""}},[_vm._v("\n\t\t¿Desea eliminar el área \""+_vm._s(_vm.name)+"\" del listado?\n\t")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54419764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configuration/delete-area.vue
// module id = 2458
// module chunks = 52